{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "materials": {
    "raw": [
      {
        "key": "antimony",
        "name": "Antimony",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category7",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "arsenic",
        "name": "Arsenic",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category6",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mission reward"
        ]
      },
      {
        "key": "boron",
        "name": "Boron",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category7",
        "origins": [
          "Surface prospecting",
          "Mining"
        ]
      },
      {
        "key": "cadmium",
        "name": "Cadmium",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category3",
        "origins": [
          "Surface prospecting",
          "Mining"
        ]
      },
      {
        "key": "carbon",
        "name": "Carbon",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category1",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "chromium",
        "name": "Chromium",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category2",
        "origins": [
          "Surface prospecting",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "germanium",
        "name": "Germanium",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category5",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "iron",
        "name": "Iron",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category4",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "lead",
        "name": "Lead",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category7",
        "origins": [
          "Surface prospecting",
          "Mining"
        ]
      },
      {
        "key": "manganese",
        "name": "Manganese",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category3",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "mercury",
        "name": "Mercury",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category6",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "molybdenum",
        "name": "Molybdenum",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category2",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "nickel",
        "name": "Nickel",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category5",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "niobium",
        "name": "Niobium",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category1",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "phosphorus",
        "name": "Phosphorus",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category2",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "polonium",
        "name": "Polonium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category6",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "rhenium",
        "name": "Rhenium",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category6",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "ruthenium",
        "name": "Ruthenium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category3",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "selenium",
        "name": "Selenium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category4",
        "origins": [
          "Surface prospecting",
          "Mission reward"
        ]
      },
      {
        "key": "sulphur",
        "name": "Sulphur",
        "category": "raw",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Category3",
        "origins": [
          "Surface prospecting",
          "Mining",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "technetium",
        "name": "Technetium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category2",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "tellurium",
        "name": "Tellurium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category5",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "tin",
        "name": "Tin",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category4",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "tungsten",
        "name": "Tungsten",
        "category": "raw",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Category5",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "vanadium",
        "name": "Vanadium",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category1",
        "origins": [
          "Surface prospecting",
          "Mining (ice rings)"
        ]
      },
      {
        "key": "yttrium",
        "name": "Yttrium",
        "category": "raw",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Category1",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "zinc",
        "name": "Zinc",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category4",
        "origins": [
          "Surface prospecting"
        ]
      },
      {
        "key": "zirconium",
        "name": "Zirconium",
        "category": "raw",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Category7",
        "origins": [
          "Surface prospecting",
          "Mining"
        ]
      }
    ],
    "manufactured": [
      {
        "key": "basicconductors",
        "name": "Basic Conductors",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Conductive",
        "origins": [
          "Ship salvage (transport ships)"
        ]
      },
      {
        "key": "tg_biomechanicalconduits",
        "name": "Bio-Mechanical Conduits",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidShip",
        "origins": [
          "Ship salvage (Thargoid ships)"
        ]
      },
      {
        "key": "biotechconductors",
        "name": "Biotech Conductors",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Conductive",
        "origins": [
          "Mission reward"
        ]
      },
      {
        "key": "chemicaldistillery",
        "name": "Chemical Distillery",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Chemical",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (high security)"
        ]
      },
      {
        "key": "chemicalmanipulators",
        "name": "Chemical Manipulators",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Chemical",
        "origins": [
          "Ship salvage (transport ships)",
          "Surface POI"
        ]
      },
      {
        "key": "chemicalprocessors",
        "name": "Chemical Processors",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Chemical",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (high security)",
          "Mission reward"
        ]
      },
      {
        "key": "chemicalstorageunits",
        "name": "Chemical Storage Units",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Chemical",
        "origins": [
          "Ship salvage (transport ships)"
        ]
      },
      {
        "key": "compactcomposites",
        "name": "Compact Composites",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Composite",
        "origins": [
          "Signal source",
          "Surface POI"
        ]
      },
      {
        "key": "compoundshielding",
        "name": "Compound Shielding",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Shielding",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source (high security)",
          "Mission reward"
        ]
      },
      {
        "key": "conductiveceramics",
        "name": "Conductive Ceramics",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Conductive",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (anarchy)"
        ]
      },
      {
        "key": "conductivecomponents",
        "name": "Conductive Components",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Conductive",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (anarchy)"
        ]
      },
      {
        "key": "conductivepolymers",
        "name": "Conductive Polymers",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Conductive",
        "origins": [
          "Ship salvage (transport ships)",
          "Surface POI",
          "Mission reward"
        ]
      },
      {
        "key": "configurablecomponents",
        "name": "Configurable Components",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "MechanicalComponents",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (low security)"
        ]
      },
      {
        "key": "fedcorecomposites",
        "name": "Core Dynamics Composites",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Composite",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source (High grade emissions, Federation systems)"
        ]
      },
      {
        "key": "crystalshards",
        "name": "Crystal Shards",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Crystals",
        "origins": [
          "Ship salvage (combat ships)",
          "Surface POI"
        ]
      },
      {
        "key": "electrochemicalarrays",
        "name": "Electrochemical Arrays",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Capacitors",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source (anarchy)"
        ]
      },
      {
        "key": "exquisitefocuscrystals",
        "name": "Exquisite Focus Crystals",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Crystals",
        "origins": [
          "Mission reward"
        ]
      },
      {
        "key": "filamentcomposites",
        "name": "Filament Composites",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Composite",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source"
        ]
      },
      {
        "key": "uncutfocuscrystals",
        "name": "Flawed Focus Crystals",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Crystals",
        "origins": [
          "Signal source"
        ]
      },
      {
        "key": "focuscrystals",
        "name": "Focus Crystals",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Crystals",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source (high security)"
        ]
      },
      {
        "key": "galvanisingalloys",
        "name": "Galvanising Alloys",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Alloys",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "gridresistors",
        "name": "Grid Resistors",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Capacitors",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "guardian_powercell",
        "name": "Guardian Power Cell",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_powerconduit",
        "name": "Guardian Power Conduit",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_sentinel_weaponparts",
        "name": "Guardian Sentinel Weapon Parts",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_techcomponent",
        "name": "Guardian Technology Component",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_sentinel_wreckagecomponents",
        "name": "Guardian Wreckage Components",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "heatconductionwiring",
        "name": "Heat Conduction Wiring",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Heat",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "heatdispersionplate",
        "name": "Heat Dispersion Plate",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Heat",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "heatexchangers",
        "name": "Heat Exchangers",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Heat",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (anarchy)"
        ]
      },
      {
        "key": "heatresistantceramics",
        "name": "Heat Resistant Ceramics",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Thermic",
        "origins": [
          "Ship salvage (transport ships)"
        ]
      },
      {
        "key": "heatvanes",
        "name": "Heat Vanes",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Heat",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "highdensitycomposites",
        "name": "High Density Composites",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Composite",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source (low security)"
        ]
      },
      {
        "key": "hybridcapacitors",
        "name": "Hybrid Capacitors",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Capacitors",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "imperialshielding",
        "name": "Imperial Shielding",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Shielding",
        "origins": [
          "Signal source (High grade emissions, Empire systems)",
          "Mission reward"
        ]
      },
      {
        "key": "improvisedcomponents",
        "name": "Improvised Components",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "MechanicalComponents",
        "origins": [
          "Signal source (High grade emissions, Civil unrest)",
          "Mission reward"
        ]
      },
      {
        "key": "mechanicalcomponents",
        "name": "Mechanical Components",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "MechanicalComponents",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source (low security)"
        ]
      },
      {
        "key": "mechanicalequipment",
        "name": "Mechanical Equipment",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "MechanicalComponents",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source"
        ]
      },
      {
        "key": "mechanicalscrap",
        "name": "Mechanical Scrap",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "MechanicalComponents",
        "origins": [
          "Ship salvage (transport ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "militarygradealloys",
        "name": "Military Grade Alloys",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Thermic",
        "origins": [
          "Signal source (High grade emissions, War/Civil war)",
          "Mission reward"
        ]
      },
      {
        "key": "militarysupercapacitors",
        "name": "Military Supercapacitors",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Capacitors",
        "origins": [
          "Signal source (High grade emissions, War/Civil war)",
          "Mission reward"
        ]
      },
      {
        "key": "pharmaceuticalisolators",
        "name": "Pharmaceutical Isolators",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Chemical",
        "origins": [
          "Mission reward",
          "Signal source (High grade emissions, Outbreak)"
        ]
      },
      {
        "key": "phasealloys",
        "name": "Phase Alloys",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Alloys",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source (low security)"
        ]
      },
      {
        "key": "polymercapacitors",
        "name": "Polymer Capacitors",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Capacitors",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "precipitatedalloys",
        "name": "Precipitated Alloys",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Thermic",
        "origins": [
          "Ship salvage (military & authority ships)",
          "Mission reward"
        ]
      },
      {
        "key": "fedproprietarycomposites",
        "name": "Proprietary Composites",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Composite",
        "origins": [
          "Signal source (High grade emissions, Federation systems)",
          "Mission reward"
        ]
      },
      {
        "key": "tg_propulsionelement",
        "name": "Propulsion Elements",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "ThargoidShip",
        "origins": [
          "Ship salvage (Thargoid ships)"
        ]
      },
      {
        "key": "protoheatradiators",
        "name": "Proto Heat Radiators",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Heat",
        "origins": [
          "Signal source (High grade emissions, Boom)",
          "Mission reward"
        ]
      },
      {
        "key": "protolightalloys",
        "name": "Proto Light Alloys",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Alloys",
        "origins": [
          "Signal source (High grade emissions, Boom)",
          "Mission reward"
        ]
      },
      {
        "key": "protoradiolicalloys",
        "name": "Proto Radiolic Alloys",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "Alloys",
        "origins": [
          "Signal source (High grade emissions, Boom)"
        ]
      },
      {
        "key": "refinedfocuscrystals",
        "name": "Refined Focus Crystals",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Crystals",
        "origins": [
          "Mission reward",
          "Signal source (high security)"
        ]
      },
      {
        "key": "salvagedalloys",
        "name": "Salvaged Alloys",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Alloys",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source"
        ]
      },
      {
        "key": "unknownenergysource",
        "name": "Sensor Fragment",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "ThargoidSite",
        "origins": [
          "Thargoid Scavengers, Destroyed Thargoid Sensor",
          "Needed for Professor Palin (25)"
        ]
      },
      {
        "key": "shieldemitters",
        "name": "Shield Emitters",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "Shielding",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source"
        ]
      },
      {
        "key": "shieldingsensors",
        "name": "Shielding Sensors",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "Shielding",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source (high security)",
          "Mission reward"
        ]
      },
      {
        "key": "temperedalloys",
        "name": "Tempered Alloys",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Thermic",
        "origins": [
          "Ship salvage (combat ships)"
        ]
      },
      {
        "key": "unknowncarapace",
        "name": "Thargoid Carapace",
        "category": "manufactured",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "ThargoidSite",
        "origins": [
          "Thargoid scavengers"
        ]
      },
      {
        "key": "unknownenergycell",
        "name": "Thargoid Energy Cell",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidSite",
        "origins": [
          "Thargoid scavengers"
        ]
      },
      {
        "key": "unknownorganiccircuitry",
        "name": "Thargoid Organic Circuitry",
        "category": "manufactured",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "ThargoidSite",
        "origins": [
          "Thargoid scavengers"
        ]
      },
      {
        "key": "unknowntechnologycomponents",
        "name": "Thargoid Technological Components",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidSite",
        "origins": [
          "Thargoid scavengers"
        ]
      },
      {
        "key": "thermicalloys",
        "name": "Thermic Alloys",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "Thermic",
        "origins": [
          "Ship salvage (combat ships)",
          "Mission reward"
        ]
      },
      {
        "key": "tg_weaponparts",
        "name": "Weapon Parts",
        "category": "manufactured",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidShip",
        "origins": [
          "Ship salvage (Thargoid ships)"
        ]
      },
      {
        "key": "wornshieldemitters",
        "name": "Worn Shield Emitters",
        "category": "manufactured",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "Shielding",
        "origins": [
          "Ship salvage (combat ships)",
          "Signal source"
        ]
      },
      {
        "key": "tg_wreckagecomponents",
        "name": "Wreckage Components",
        "category": "manufactured",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidShip",
        "origins": [
          "Ship salvage (Thargoid ships)"
        ]
      }
    ],
    "encoded": [
      {
        "key": "aberrantshieldpatternanalysis",
        "name": "Aberrant Shield Pattern Analysis",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ShieldData",
        "origins": [
          "Ship scanning (combat ships)",
          "Mission reward",
          "Needed for The Sarge (50)"
        ]
      },
      {
        "key": "compactemissionsdata",
        "name": "Abnormal Compact Emission Data",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "EmissionData",
        "origins": [
          "Deep space data beacon",
          "Ship scanning (combat ships)",
          "Mission reward"
        ]
      },
      {
        "key": "adaptiveencryptorscapture",
        "name": "Adaptive Encryptors Capture",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "EncryptionFiles",
        "origins": [
          "Mission reward",
          "Signal source"
        ]
      },
      {
        "key": "anomalousbulkscandata",
        "name": "Anomalous Bulk Scan Data",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "DataArchives",
        "origins": [
          "Ship scanning (transport ships)",
          "Mission reward"
        ]
      },
      {
        "key": "anomalousfsdtelemetry",
        "name": "Anomalous FSD Telemetry",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "WakeScans",
        "origins": [
          "High wake scanning",
          "Mission reward"
        ]
      },
      {
        "key": "atypicaldisruptedwakeechoes",
        "name": "Atypical Disrupted Wake Echoes",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "WakeScans",
        "origins": [
          "High wake scanning",
          "Mission reward"
        ]
      },
      {
        "key": "atypicalencryptionarchives",
        "name": "Atypical Encryption Archives",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "EncryptionFiles",
        "origins": [
          "Surface POI",
          "Signal source"
        ]
      },
      {
        "key": "scandatabanks",
        "name": "Classified Scan Databanks",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "DataArchives",
        "origins": [
          "Ship scanning (transport ships)",
          "Surface POI",
          "Needed for Ram Tah (50)"
        ]
      },
      {
        "key": "classifiedscandata",
        "name": "Classified Scan Fragment",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "DataArchives",
        "origins": [
          "Surface data point",
          "Mission reward"
        ]
      },
      {
        "key": "crackedindustrialfirmware",
        "name": "Cracked Industrial Firmware",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "EncodedFirmware",
        "origins": [
          "Surface data point",
          "Mission reward"
        ]
      },
      {
        "key": "dataminedwakeexceptions",
        "name": "Datamined Wake Exceptions",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "WakeScans",
        "origins": [
          "High wake scanning",
          "Mission reward"
        ]
      },
      {
        "key": "decodedemissiondata",
        "name": "Decoded Emission Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "EmissionData",
        "origins": [
          "Ship scanning (combat ships)",
          "Mission reward",
          "Needed for Tiana Fortune (50)"
        ]
      },
      {
        "key": "distortedshieldcyclerecordings",
        "name": "Distorted Shield Cycle Recordings",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "ShieldData",
        "origins": [
          "Ship scanning (transport ships)",
          "Mission reward"
        ]
      },
      {
        "key": "encodedscandata",
        "name": "Divergent Scan Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "DataArchives",
        "origins": [
          "Surface data point",
          "Mission reward"
        ]
      },
      {
        "key": "eccentrichyperspacetrajectories",
        "name": "Eccentric Hyperspace Trajectories",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "WakeScans",
        "origins": [
          "High wake scanning"
        ]
      },
      {
        "key": "exceptionalscrambledemissiondata",
        "name": "Exceptional Scrambled Emission Data",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "EmissionData",
        "origins": [
          "Ship scanning",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "guardian_moduleblueprint",
        "name": "Guardian Module Blueprint Segment",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_vesselblueprint",
        "name": "Guardian Vessel Blueprint Segment",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "guardian_weaponblueprint",
        "name": "Guardian Weapon Blueprint Segment",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "GuardianRuinsActive",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "inconsistentshieldsoakanalysis",
        "name": "Inconsistent Shield Soak Analysis",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "ShieldData",
        "origins": [
          "Ship scanning (transport ships)",
          "Mission reward"
        ]
      },
      {
        "key": "archivedemissiondata",
        "name": "Irregular Emission Data",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "EmissionData",
        "origins": [
          "Mission reward",
          "Signal source"
        ]
      },
      {
        "key": "tg_shutdowndata",
        "name": "Massive Energy Surge Analytics",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidShip",
        "origins": [
          "Ship scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "modifiedconsumerfirmware",
        "name": "Modified Consumer Firmware",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "EncodedFirmware",
        "origins": [
          "Mission reward",
          "Signal source",
          "Surface data point"
        ]
      },
      {
        "key": "modifiedembeddedfirmware",
        "name": "Modified Embedded Firmware",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "EncodedFirmware",
        "origins": [
          "Surface data point",
          "Mission reward"
        ]
      },
      {
        "key": "opensymmetrickeys",
        "name": "Open Symmetric Keys",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "EncryptionFiles",
        "origins": [
          "Surface data point",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "ancientbiologicaldata",
        "name": "Pattern Alpha Obelisk Data",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "GuardianRuins",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "ancientculturaldata",
        "name": "Pattern Beta Obelisk Data",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "GuardianRuins",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "ancientlanguagedata",
        "name": "Pattern Delta Obelisk Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "GuardianRuins",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "ancienttechnologicaldata",
        "name": "Pattern Epsilon Obelisk Data",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "GuardianRuins",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "ancienthistoricaldata",
        "name": "Pattern Gamma Obelisk Data",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "GuardianRuins",
        "origins": [
          "Ancient/Guardian ruins"
        ]
      },
      {
        "key": "peculiarshieldfrequencydata",
        "name": "Peculiar Shield Frequency Data",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "ShieldData",
        "origins": [
          "Ship scanning",
          "Mission reward"
        ]
      },
      {
        "key": "securityfirmwarepatch",
        "name": "Security Firmware Patch",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "EncodedFirmware",
        "origins": [
          "Surface data point",
          "Mission reward"
        ]
      },
      {
        "key": "tg_shipflightdata",
        "name": "Ship Flight Data",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidShip",
        "origins": [
          "Ship scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "tg_shipsystemsdata",
        "name": "Ship System Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidShip",
        "origins": [
          "Ship scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "specialisedlegacyfirmware",
        "name": "Specialised Legacy Firmware",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "EncodedFirmware",
        "origins": [
          "Mission reward",
          "Surface data point",
          "Signal source"
        ]
      },
      {
        "key": "strangewakesolutions",
        "name": "Strange Wake Solutions",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "WakeScans",
        "origins": [
          "High wake scanning",
          "Mission reward"
        ]
      },
      {
        "key": "taggedencryptioncodes",
        "name": "Tagged Encryption Codes",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "EncryptionFiles",
        "origins": [
          "Surface data point",
          "Signal source",
          "Mission reward"
        ]
      },
      {
        "key": "tg_interdictiondata",
        "name": "Thargoid Interdiction Telemetry",
        "category": "encoded",
        "rarity": "VeryRare",
        "rarityRank": 5,
        "group": "ThargoidShip",
        "origins": [
          "Ship scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "tg_compositiondata",
        "name": "Thargoid Material Composition Data",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidSite",
        "origins": [
          "Base scanning (Thargoid uplink devices)"
        ]
      },
      {
        "key": "tg_residuedata",
        "name": "Thargoid Residue Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidSite",
        "origins": [
          "Base scanning (Thargoid uplink devices)"
        ]
      },
      {
        "key": "unknownshipsignature",
        "name": "Thargoid Ship Signature",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ThargoidShip",
        "origins": [
          "Ship scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "tg_structuraldata",
        "name": "Thargoid Structural Data",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "ThargoidSite",
        "origins": [
          "Base scanning (Thargoid uplink devices)"
        ]
      },
      {
        "key": "unknownwakedata",
        "name": "Thargoid Wake Data",
        "category": "encoded",
        "rarity": "Rare",
        "rarityRank": 4,
        "group": "ThargoidShip",
        "origins": [
          "High wake scanning (Thargoid interceptors)"
        ]
      },
      {
        "key": "emissiondata",
        "name": "Unexpected Emission Data",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "EmissionData",
        "origins": [
          "Ship scanning (combat ships)",
          "Signal source"
        ]
      },
      {
        "key": "unidentifiedscanarchives",
        "name": "Unidentified Scan Archives",
        "category": "encoded",
        "rarity": "Common",
        "rarityRank": 2,
        "group": "DataArchives",
        "origins": [
          "Ship scanning (transport ships)"
        ]
      },
      {
        "key": "shielddensityreports",
        "name": "Untypical Shield Scans",
        "category": "encoded",
        "rarity": "Standard",
        "rarityRank": 3,
        "group": "ShieldData",
        "origins": [
          "Ship scanning (combat ships)"
        ]
      },
      {
        "key": "unusualencryptedfiles",
        "name": "Unusual Encrypted Files",
        "category": "encoded",
        "rarity": "VeryCommon",
        "rarityRank": 1,
        "group": "EncryptionFiles",
        "origins": [
          "Surface data point",
          "Signal source",
          "Mission reward"
        ]
      }
    ]
  }
}
